export const DATE_FORMAT = 'P';
export const BACKEND_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss'; // 2019-02-13 22:02:33
export const DATETIME_FORMAT = 'Pp';
export const TIME_ZONE = 'UTC';
export const MAX_FILE_SIZE = 10485760; // Max Files Size is 10 MB. Value in bytes.

export const ANNEX_OVERVIEW_EXPORT_FILE_NAME = 'annex overview.xlsx';
export const MEAL_PLANS_EXPORT_FILE_NAME = 'HN mealplanner';
export const ORDERS_EXPORT_FILE_NAME = 'orders.xlsx';
export const TICKETS_EXPORT_FILE_NAME = 'tickets.xlsx';
export const USERS_EXPORT_FILE_NAME = 'users.xlsx';

export const ERROR_LOGS_EXPORT_FILE_NAME = 'error logs.xlsx';
export const OUTBOX_LOGS_EXPORT_FILE_NAME = 'outbox logs';
export const INBOX_LOGS_EXPORT_FILE_NAME = 'inbox logs';
export const SERVER_STATUS_EXPORT_FILE_NAME = 'server status.json';

export const HN_MANUAL_FILE_NAME = 'HN user reference guide_v1.0.pdf';
export const SN_MANUAL_FILE_NAME = 'SN user reference guide_v1.0.pdf';
export const SP_MANUAL_FILE_NAME = 'SP user reference guide_v1.0.pdf';

export const GRID_CUSTOM_FILTER_FIELDS = {
  annexes: 'annexes',
  groups: 'groups',
  indicationTypes: 'indicationTypes',
  regions: 'regions',
  sendingNations: 'sendingNations',
  statuses: 'statuses',
  unitsOfMeasure: 'unitsOfMeasure',
  fullyAssigned: 'fullyAssigned',
  locations: 'locations',
  locationsTo: 'locationsTo',
  Suppliers: 'suppliers',
  appointedUnits: 'appointedUnits',
  groupNames: 'groupNames'
};

// Page sizes for kendo grid.
// https://www.telerik.com/kendo-react-ui/components/grid/api/GridProps/#toc-pageable
export const PAGE_SIZES = [5, 10, 20, 50, 100];

export const ORDER_STATUSES = {
  0: {
    type: '',
    color: '#F66D00'
  },
  1: {
    type: 'OrderDraft',
    color: '#F66D00'
  },
  2: {
    type: 'Ordered',
    color: '#92B99F'
  },
  3: {
    type: 'Canceled',
    color: '#868B9E'
  }
};

export const TICKETS_STATUSES = {
  0: {
    type: 'New',
    color: '#FDAD00'
  },
  1: {
    type: 'Assigned',
    color: '#EC5E00'
  },
  2: {
    type: 'Replied',
    color: '#9B26AF'
  },
  3: {
    type: 'Resolved',
    color: '#1E7A5A'
  },
  4: {
    type: 'Rejected',
    color: '#BA3058'
  }
};

export const STATUSES = {
  0: {
    type: 'New',
    color: '#FED004'
  },
  1: {
    type: 'Replied',
    color: '#094DCC'
  },
  2: {
    type: 'Removed',
    color: '#868B9E'
  },
  3: {
    type: 'Edited',
    color: '#FE9904'
  },
  4: {
    type: 'Confirmed',
    color: '#49C78F'
  },
  5: {
    type: 'OrderDraft',
    color: '#F66D00'
  },
  6: {
    type: 'Ordered',
    color: '#92B99F'
  },
  7: {
    type: 'OrderRejected',
    color: '#BA3058'
  },
  8: {
    type: 'OrderConfirmed',
    color: '#49C78F'
  },
  9: {
    type: 'Delivered',
    color: '#1E7A5A'
  },
  10: {
    type: 'Invoiced',
    color: '#2195F2'
  },
  11: {
    type: 'NewCategory',
    color: '#FED004' // no
  },
  12: {
    type: 'ResolvedCategory',
    color: '#868B9E' // no
  },
  13: {
    type: 'Cancelled',
    color: '#c00000'
  },
  14: {
    type: 'PartiallyInvoiced',
    color: '#2195F2'
  },
  15: {
    type: 'Rejected',
    color: '#bc2b58'
  }
};

export const DELIVERY_LINE_STATUSES = {
  1: {
    type: 'Delivered',
    color: '#1E7A5A'
  },
  2: {
    type: 'Invoiced',
    color: '#2195F2'
  }
};

export const SERVER_STATUSES = {
  0: {
    type: 'Unhealthy',
    color: '#FF5555'
  },
  1: {
    type: 'Degraded',
    color: '#FE9904'
  },
  2: {
    type: 'Healthy',
    color: '#49C78F'
  },
  3: {
    type: 'Pending',
    color: '#FED004'
  },
  4: {
    type: 'Failed',
    color: '#868B9E'
  }
};

/**
 * ð
 * Easiest way to format filters for default selected fields:
 * @hobs/components/Grid/ColumnMenu/ColumnMenu.js - createCustomFilter
 * log the results of selected fields and apply them here, thats EZ
 */
export const DEFAULT_STATUS_FILTER = {
  filters: [
    { field: 'StatusId', operator: 'eq', value: 0 },
    { field: 'StatusId', operator: 'eq', value: 1 },
    { field: 'StatusId', operator: 'eq', value: 3 },
    { field: 'StatusId', operator: 'eq', value: 4 },
    { field: 'StatusId', operator: 'eq', value: 5 },
    { field: 'StatusId', operator: 'eq', value: 6 },
    { field: 'StatusId', operator: 'eq', value: 7 },
    { field: 'StatusId', operator: 'eq', value: 8 },
    { field: 'StatusId', operator: 'eq', value: 9 },
    { field: 'StatusId', operator: 'eq', value: 10 },
    { field: 'StatusId', operator: 'eq', value: 11 },
    { field: 'StatusId', operator: 'eq', value: 13 },
    { field: 'StatusId', operator: 'eq', value: 14 },
    { field: 'StatusId', operator: 'eq', value: 15 }
  ],
  logic: 'or'
};

export const DEFAULT_DAYS_UNTIL_USER_EXPIRE = 180;

export const COR_STATUS_TYPES = {
  1: {
    intent: 'danger',
    icon: 'small-cross'
  },
  2: {
    intent: 'warning',
    icon: 'info-sign'
  },
  3: {
    intent: 'success',
    icon: 'small-tick'
  },
  4: {
    intent: 'none',
    icon: 'small-cross'
  }
};

export const GRID_OPERATORS = {
  text: [
    { text: 'Starts with', operator: 'startswith' },
    { text: 'Contains', operator: 'contains' },
    { text: 'Is equal to', operator: 'eq' }
  ],
  numeric: [
    { text: 'Is equal to', operator: 'eq' },
    { text: 'Is greater than', operator: 'gte' },
    { text: 'Is less than', operator: 'lte' }
  ],
  date: [
    { text: 'From date', operator: 'gte' },
    { text: 'To date', operator: 'lte' }
  ]
};

export const USER_ROLES = {
  SystemAdmin: 'SystemAdmin',
  ADMIN: 'Admin',
  USER: 'User',
  READONLY: 'Readonly',
  HOST_UNIT: 'HostUnit'
};

export const UNIT_PARENT_TYPES = {
  Unit: null,
  SubUnit: 'Unit',
  Component: 'SubUnit'
};

export const UNIT_TYPES = {
  Unit: 'Unit',
  SubUnit: 'SubUnit',
  Component: 'Component'
};

export const INDICATIONS = {
  CategoryNotResolved: 'Category not resolved',
  HasNewMessages: 'Unread message',
  IsNotFullOrdered: 'Not fully ordered',
  IsReplyToSnIsMissing: 'Response is not sent',
  QuantityNotAssigned: 'Quantity not assigned',
  SupplierUpdateToService: 'Supplier update to Service',
  TransportationInformationMissing: 'Transportation info. not filled',
  AddReqResponseRequired: 'Change response not confirmed',
  IsEarlyConfirmationRequired: 'Early confirmation required'
};

export const MAX_INT32 = 2147483647;

export const SERVICE_REQUEST_NAVIGATION_ORIGIN = {
  AnnexOverview: 'AnnexOverview',
  RequestedServices: 'RequestedServices',
  Orders: 'Orders',
  Tickets: 'Tickets'
};

export const PARTY_NAVIGATION_ORIGIN = {
  Parties: 'Parties',
  AllUsers: 'AllUsers'
};

export const APPROVAL_STATUSES = {
  0: {
    type: 'Pending',
    color: '#FED004'
  },
  1: {
    type: 'Approved',
    color: '#49C78F'
  }
};

export const SERVICE_REQUEST_FOOTER_STATUSES = {
  None: 'None',
  AdditionalCreateConfirm: 'AdditionalCreateConfirm',
  AdditionalCreateWaitingForHn: 'AdditionalCreateWaitingForHn',
  AdditionalCreateWaitingForSn: 'AdditionalCreateWaitingForSn',
  AdditionalCreateAccept: 'AdditionalCreateAccept',
  RequestForCancellation: 'RequestForCancellation',
  AdditionalChangeConfirm: 'AdditionalChangeConfirm',
  AdditionalChangeWaitingForHn: 'AdditionalChangeWaitingForHn',
  AdditionalChangeWaitingForSn: 'AdditionalChangeWaitingForSn',
  AdditionalChangeAccept: 'AdditionalChangeAccept',
  AdditionalCancellationWaitingForHn: 'AdditionalCancellationWaitingForHn',
  AdditionalCancellationConfirm: 'AdditionalCancellationConfirm'
};

export const MONTH_NAMES = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December'
};

export const HEALTH_CHECK_REFRESH_INTERVAL = 10000;

export const PARTY_TYPE = {
  HostNation: {
    Id: 1,
    Name: 'Host Nation'
  },
  SendingNation: {
    Id: 2,
    Name: 'Sending Nation'
  },
  Supplier: {
    Id: 3,
    Name: 'Supplier'
  }
};

export const SOR_PHASE_TYPES = {
  Fsor: 3
};

export const PHASE_TYPES = {
  ISOR: {
    id: 1,
    name: 'ISOR'
  },
  Planning: {
    id: 2,
    name: 'Planning'
  },
  FSOR: {
    id: 3,
    name: 'FSOR'
  },
  Execution: {
    id: 4,
    name: 'Execution'
  },
  Billing: {
    id: 5,
    name: 'Billing'
  },
  Finished: {
    id: 6,
    name: 'Finished'
  }
};

export const ACCEPTED_FILE_FORMATS = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/msword',
  '.txt',
  '.xslx',
  '.xlsx',
  '.csv',
  'application/pdf',
  '.xls',
  'image/jpg',
  'image/jpeg',
  'image/png',
  '.ppt',
  '.pptx',
  '.odp',
  '.msg'
];

export const NO_PATH = '---';
export const ENVIRONMENT_PATHS = [
  '/test-sn',
  '/test-sp',
  '/hn-fe',
  '/sn-fe',
  '/sp-fe',
  '/test'
];

export const EMAIL_NOTIFICATION_TABS = {
  CurrentExercise: 0,
  Global: 1,
  AnnexSettings: 2
};

export const SERVICE_REQUEST_COPY_VALIDATION_ERRORS = {
  1: 'Unit is invalid',
  2: 'Activity is invalid',
  3: 'Location from is invalid',
  4: 'Location to is invalid'
};
